function TermsContentFr() {

  return (
    <div className="terms_condition_section" dir="rtl">
    <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="term-contition-wrapper poppingsregular">
              <h2>Conditions d'utilisation</h2>
              <div className="terms-condition-block">
                <p>
                  Bienvenue sur Houmti, exploité par CloudWind LLC (la « Société », « Houmti », « nous » ou « nous »).
              </p>
                <p>En accédant l'application Houmti ou son site Web à <a href="https://www.houmti.io">https://www.houmti.io</a>, que ce soit
                via un appareil mobile, une application mobile ou un ordinateur (collectivement, le «Service»), vous (l
                '«Utilisateur») acceptez
                d'être lié par les présentes Conditions d'utilisation (le présent «Contrat»), que vous créiez ou non un
                Compte Houmti. Si vous souhaitez créer un compte sur Houmti et utilisez notre service, vous devez lire
                et accepter
                ces Conditions d'utilisationhttps.:

              </p>
                <p>Vous devez également lire la politique de confidentialité Houmti, qui est référencée à plusieurs
                reprises dans l'Accord et disponible dans l’intégralité à adresse <a
                    href="www.houmti.io/privacy-policy">www.houmti.io/privacy-policy</a>. Si vous n'acceptez
                pas et acceptez d'être lié par toutes les conditions contenues dans cet accord, y compris la politique
                de confidentialité de Houmti, veuillez ne pas utiliser le service. Veuillez nous contacter pour toute
                question concernant
                cet accord.
              </p>
                <ol className="listing-wrapper">
                  <li>Votre acceptation de nos conditions d'utilisation
                  <ol>
                      <li>Cet accord est un contrat électronique qui établit les conditions juridiquement contraignantes
                      que vous devez accepter pour utiliser le Service. N'oubliez pas qu'en accédant à cette application
                      sur des plateformes
                      Web ou mobiles, vous acceptez d'être lié par les présentes conditions d'utilisation, toutes les
                      lois et réglementations applicables, et acceptez que vous êtes responsable du respect des lois
                      locales applicables.
                      Si vous n'acceptez aucune de ces conditions, il se peut qu'il vous soit interdit d'utiliser ou
                      d'accéder à ce site. Le matériel contenu dans ce site Web est protégé par le droit d'auteur et le
                      droit des marques
                      en vigueur.
                    </li>
                      <li>Si vous souhaitez retirer votre consentement, vous devez résilier votre compte et cesser
                      complètement d'utiliser le Service. Nous vous encourageons à imprimer une copie de cet accord pour
                      vos dossiers. N'oubliez
                      pas que cet accord peut être modifié par Houmti à tout moment et qu'il est effectif une fois qu'il
                      est publié sur le Service. Nous vous encourageons à revenir fréquemment pour toute modification de
                      nos conditions
                      d'utilisation.
                    </li>
                    </ol>
                  </li>
                  <li>Admissibilité
                  <ol>
                      <li>Houmti est un Service offert gratuitement pour permettre aux membres d'une communauté définie
                      par une frontière géographique telle que la Daira ou la Wilaya de communiquer entre eux et
                      d'utiliser les services offerts
                      à travers les fonctions de l'application. Toute utilisation du Service est nulle là où elle est
                      interdite. En accédant au Service et en l'utilisant, vous déclarez et garantissez que vous avez le
                      droit et l'autorité
                      d'utiliser le Service et de respecter tous les termes et conditions qui vous sont présentés dans
                      le présent Contrat.

                    </li>
                      <li>Si vous créez un compte, vous déclarez et garantissez que vous vivez actuellement dans la zone
                      que vous avez partagée lors de votre inscription.
                    </li>
                    </ol>
                  </li>
                  <li>Inscription à Houmti
                  <ol>
                      <li>Pour utiliser Houmti, vous devez vous inscrire avec une adresse e-mail valide et vérifiable. Ce
                      faisant, vous nous autorisez à vous envoyer des courriels qui peuvent inclure, mais sans s'y
                      limiter, des questions
                      concernant votre satisfaction à l'égard de notre service ou des demandes de remplir des sondages
                      concernant notre service. Pour plus d'informations sur la manière dont nous utilisons et
                      collectons vos informations,
                      veuillez consulter notre politique de confidentialité.

                    </li>
                    </ol>
                  </li>
                  <li>Licence d'utilisation La
                  <ol>
                      <li>permission est accordée pour télécharger temporairement une (1) copie du matériel (information
                      ou logiciel) sur le site Web de Houmti pour une visualisation transitoire personnelle et non
                      commerciale uniquement.
                      Il s'agit de l'octroi d'une licence, pas d'un transfert de titre, et sous cette licence, vous ne
                      pouvez pas: modifier ou copier le matériel; utiliser le matériel à des fins commerciales ou pour
                      tout affichage
                      public (commercial ou non commercial); tenter de décompiler ou de désosser tout logiciel contenu
                      sur le site Web de Houmti; supprimer tout droit d'auteur ou autres notations de propriété du
                      matériel; ou transférer
                      les documents à une autre personne ou «reproduire» les documents sur tout autre serveur.

                    </li>
                      <li>Cette licence sera automatiquement résiliée si vous violez l'une de ces restrictions et peut
                      être résiliée par Houmti à tout moment. À la fin de votre consultation de ces documents ou à la
                      résiliation de cette licence,
                      vous devez détruire tout matériel téléchargé en votre possession, que ce soit sous forme
                      électronique ou imprimée
                    </li>
                    </ol>
                  </li>
                  <li>Résiliation de cet accord
                  <ol>
                      <li>Cet accord restera valide et en plein effet tant que vous utilisez le service et / ou que vous
                      avez un compte Houmti. Vous pouvez désactiver votre compte à tout moment, pour quelque raison que
                      ce soit, en suivant
                      les instructions dans «Paramètres» du Service.
                    </li>
                      <li>Houmti se réserve le droit de résilier ou de suspendre votre compte à tout moment sans préavis
                      si la Société estime que vous avez violé le présent Accord, ou pour toute autre raison, avec ou
                      sans motif, à sa seule
                      discrétion.
                    </li>
                      <li>Houmti n'est pas tenu de divulguer, et peut être interdit par la loi de divulguer, la raison de
                      la résiliation ou de la suspension de votre compte.
                    </li>
                      <li>Après une telle résiliation ou suspension, tous les termes du présent accord en plus des termes
                      de notre politique de confidentialité survivent à cette résiliation et restent pleinement en
                      vigueur, à moins qu'ils
                      n'expirent par nature ou soient pleinement satisfaits.
                    </li>
                    </ol>
                  </li>
                  <li>Vos interactions avec d'autres utilisateurs
                  <ol>
                      <li>Vous êtes seul responsable de vos interactions avec les autres utilisateurs.
                    </li>
                      <li>Vous comprenez que la société ne s'enquiert actuellement pas des antécédents de tous ses
                      utilisateurs ni ne tente de vérifier l'exactitude des informations fournies par ses utilisateurs.
                      Nous ne faisons aucune représentation
                      ou garantie quant à la conduite de nos utilisateurs et nous nous réservons le droit de procéder à
                      une vérification des antécédents criminels ou à d'autres examens à tout moment.
                    </li>
                      <li>Houmti n'est pas responsable de la conduite de tout utilisateur. En aucun cas Houmti, ses
                      affiliés ou ses partenaires ne pourront être tenus responsables des pertes ou dommages de quelque
                      nature que ce soit résultant
                      de l'utilisation de notre Service. Cependant, nous ferons de notre mieux pour remédier à toute
                      situation de conflit pouvant survenir lors de l'interaction avec d'autres utilisateurs.</li>
                      <li>Vous acceptez de prendre toutes les précautions nécessaires dans toutes les interactions avec
                      d'autres utilisateurs, en particulier si vous acceptez de vous rencontrer en personne ou de
                      communiquer en utilisant
                      un service différent.
                    </li>
                      <li>Pour éviter toute ambiguïté, Houmti, ses affiliés ou ses partenaires ne seront en aucun cas
                      responsables de votre comportement ou de celui de tout autre utilisateur qui enfreint les lois,
                      réglementations et / ou
                      politiques universitaires applicables liées.
                    </li>
                      <li>Vous ne devez pas fournir vos informations financières ou envoyer de l'argent à d'autres
                      utilisateurs de Houmti.</li>
                    </ol>
                  </li>
                  <li>Contenu créé par vous, l'utilisateur, dans notre service.
                  <ol>
                      <li>Vous êtes seul responsable de tout contenu et information que vous mettez à disposition sur le
                      service (ci-après, «publication»). Cela comprend les messages texte, les chats, les chats vidéo,
                      les photographies et
                      le texte de profil (ci-après, «contenu»).
                    </li>
                      <li>Il vous est interdit de publier tout contenu offensant, vulgaire, raciste, profane, menaçant ou
                      illégal, ou tout contenu qui enfreint ou viole les droits d'une autre personne.
                    </li>
                      <li>
                        Vous déclarez et garantissez que:
                      <ol>
                          <li>Toutes les informations que vous soumettez lors de la création de votre compte sont exactes
                          et véridiques et que vous mettrez à jour toute information si son exactitude ou sa véracité
                          change à tout moment
                          pour quelque raison que ce soit,</li>
                          <li>Vous avez le droit de publier le contenu sur le Le service doit respecter les
                          réglementations ci-dessus.
                        </li>
                        </ol>
                      </li>
                      <li>Vous comprenez et acceptez que nous puissions surveiller ou examiner tout le contenu que vous
                      publiez dans notre service et nous vous réservons le droit de supprimer tout contenu susmentionné
                      à notre seule discrétion.
                    </li>
                      <li>En publiant du contenu sur notre Service, vous accordez à Houmti, à nos affiliés, licenciés et
                      successeurs un droit et une licence irrévocable, perpétuel, non exclusif, transférable,
                      sous-licenciable, mondial d'utiliser,
                      copier, stocker, afficher, reproduire, enregistrer, lire, adapter, modifier et distribuer le
                      contenu que vous publiez et incorporer le contenu dans d'autres œuvres.
                    </li>
                      <li>En plus des types de contenu interdits dans la section 7.2 ci-dessus, ce qui suit est une liste
                      de certains, mais pas de tous, des contenus dont la publication sur notre service est interdite:
                      <ol>
                          <li>Prôner le harcèlement ou l'intimidation d'une autre personne
                        </li>
                          <li>Promouvoir le racisme, la haine, sectarisme ou préjudice physique contre tout groupe ou
                          individu
                        </li>
                          <li>Impliquant des activités de «spam», de «trolling» ou similaires
                        </li>
                          <li>Contenant des informations fausses ou trompeuses
                        </li>
                          <li>Contenant du matériel exploitant des personnes de manière sexuelle, violente ou illégale
                        </li>
                          <li>Contenant des ressources pédagogiques sur les activités illégales
                        </li>
                          <li>Contenant des virus , chevaux de Troie ou autres matériels nuisibles
                        </li>
                          <li>Contenant tout matériel que Houmti considère comme préjudiciable aux autres utilisateurs,
                        </li>
                        </ol>
                      </li>
                      <li>Houmti se réserve le droit d'enquêter et de prendre toute action en justice disponible contre
                      toute personne qui enfreint l'une des dispositions décrites dans 7.

                    </li>
                      <li>Vous acceptez que Houmti puisse accéder, conserver et divulguer les informations de votre compte
                      et tout contenu que vous avez déjà publié si la loi l'exige ou si w Nous pensons, à notre seule
                      discrétion, que nous
                      devrions le faire.
                    </li>
                      <li>Vous acceptez que tout autre utilisateur ou personne participant au Service puisse voir tout
                      contenu que vous publiez sur notre Service.
                    </li>
                    </ol>
                  </li>
                  <li>Activités interdites
                  <ol>
                      <li>Vous trouverez ci-dessous une liste de certaines, mais pas toutes, des actions dans lesquelles
                      vous ne pouvez pas vous engager en ce qui concerne notre service. Vous ne pourrez:
                    </li>
                      <ol>
                        <li>publier aucun contenu interdit dans la section 7
                      </li>
                        <li>traquer ou harceler un utilisateur
                      </li>
                        <li>utiliser Houmti de manière illégale ou commettre un acte illégal
                      </li>
                        <li>utiliser Houmti pour commettre un acte qui enfreint les lois, règlements ou politiques
                        universitaires liés de
                      </li>
                        <li>quelque manière que ce soit reproduire ou contourner la structure de navigation ou la
                        présentation du Service ou de son contenu
                      </li>
                        <li>Interférer ou perturber le Service ou ses serveurs ou réseaux
                      </li>
                        <li>Publier ou transmettre tout matériel contenant des virus logiciels, chevaux de Troie ou tout
                        autre code conçu pour interférer de quelque manière que ce soit avec les logiciels, le matériel
                        ou équipement de télécommunication
                      </li>
                        <li>Usurper l'identité de toute personne, utilisateur ou entité, en particulier, mais sans s'y
                        limiter, un membre de l'équipe Houmti</li>
                        <li>Reproduire une partie de notre service sans notre autorisation écrite préalable</li>
                        <li>Screen scrape ou data mine tout contenu ou information obtenu à partir du service sauf si est
                        conforme à cet accord.
                      </li>
                      </ol>
                    </ol>
                  </li>
                  <li>L'utilisation commerciale de notre service
                  <ol>
                      <li>Houmti est offerte gratuitement pour un usage personnel. Les utilisateurs ne peuvent pas
                      utiliser le service ou l'un de ses contenus dans le cadre de toute entreprise commerciale sans le
                      consentement préalable de
                      Houmti et de ses affiliés. Ces efforts peuvent inclure, mais ne sont pas limités à:

                      <ol>
                          <li>La publicité ou la sollicitation de tout utilisateur pour acheter ou vendre des produits ou
                          services
                        </li>
                          <li>Solliciter d'autres utilisateurs pour assister à des fêtes ou à d'autres fonctions sociales
                          en violation de la réglementation en vigueur relative</li>
                          <li>Solliciter d'autres utilisateurs à commettre des actes qui enfreindre les lois,
                          réglementations et politiques applicables relatives
                        </li>
                        </ol>
                      </li>
                      <li>Les utilisateurs de ce Service ne peuvent utiliser aucune information obtenue par le biais du
                      Service pour contacter, faire de la publicité, solliciter ou vendre à tout autre utilisateur sans
                      son consentement explicite
                      préalable.
                    </li>
                      <li>Les organisations, entreprises et / ou entreprises ne peuvent pas utiliser Houmti à quelque fin
                      que ce soit sans l'accord préalable avec Houmti ou ses affiliés</li>
                      <li>Houmti se réserve le droit d'enquêter et / ou de prendre toute action légale disponible en
                      réponse à des utilisations illégales et / ou non autorisées du Service.
                    </li>
                    </ol>
                  </li>
                  <li>Sécurité du compte
                  <ol>
                      <li>Vous êtes seul responsable du maintien de la confidentialité du nom d'utilisateur et du mot de
                      passe que vous désignez pour votre compte lors de votre inscription à notre service. Vous êtes
                      seul responsable de toutes
                      les activités qui se produisent sous votre compte.
                    </li>
                      <li>Vous acceptez d'avertir immédiatement la Société si quelqu'un d'autre a un accès non autorisé à
                      votre compte ou si une autre violation de la sécurité se produit. Vous pouvez nous contacter à
                      support@houmti.io.
                    </li>
                    </ol>
                  </li>
                  <li>Liens
                  <ol>
                      <li>Houmti n'a pas examiné tous les sites et applications liés à son site Web Internet et n'est pas
                      responsable du contenu de ces sites ou applications liés. L'inclusion de tout lien n'implique pas
                      l'approbation par
                      Houmti du site. L'utilisation d'un tel site Web ou application lié est aux risques et périls de
                      l'utilisateur.
                    </li>
                    </ol>
                  </li>
                  <li>
                    Droits de propriété
                  <ol>
                      <li>Houmti possède et conserve tous les droits de propriété sur le Service et sur tout le contenu,
                      les marques, les noms commerciaux, les marques de service et les autres droits de propriété
                      intellectuelle qui y sont
                      liés.
                    </li>
                      <li>Vous acceptez de ne pas copier, modifier, transmettre, créer des œuvres dérivées, utiliser ou
                      reproduire de quelque manière que ce soit du matériel protégé par le droit d'auteur, des noms
                      commerciaux, des marques
                      de service ou toute autre propriété intellectuelle du Service sans obtenir au préalable le
                      consentement écrit de la Société ou le propriétaire de cette propriété intellectuelle.
                    </li>
                    </ol>
                  </li>
                  <li>Modération
                  <ol>
                      <li>Houmti ne tolère pas le téléchargement ou la création de contenu inapproprié au sein de la
                      plateforme. Houmti modère et supprime le contenu inapproprié, qui peut inclure, mais sans s'y
                      limiter, du matériel pornographique.
                      Les utilisateurs peuvent signaler et signaler le contenu répréhensible qu'ils voient dans
                      l'application mobile. Le contenu signalé sera examiné et les utilisateurs qui publient ledit
                      contenu peuvent être supprimés
                      du service.
                    </li>
                    </ol>
                  </li>
                  <li>Loi applicable
                  <ol>
                      <li>Toute réclamation relative au site Web ou aux applications mobiles de Houmti sera régie par les
                      lois de la République démocratique d'Algérie sans égard à ses dispositions relatives aux conflits
                      de lois. Les conditions
                      générales s'appliquent à l'utilisation d'un site Web ou d'une application mobile.

                    </li>
                    </ol>
                  </li>
                  <li>Le service client
                  <ol>
                      <li>Houmti vous fournira une assistance de temps en temps. Cependant, en communiquant avec nous,
                      vous acceptez de ne pas être abusif, offensant ou autrement inapproprié à notre égard. Si, à notre
                      seule discrétion, nous
                      trouvons que votre comportement est inapproprié de quelque manière que ce soit, nous nous
                      réservons le droit de résilier immédiatement votre compte et de prendre toute action en justice
                      disponible.
                    </li>
                    </ol>
                  </li>
                  <li>
                    Modifications de notre service
                  <ol>
                      <li>
                        Houmti se réserve le droit de modifier ou d'interrompre toute partie du service avec ou sans
                        préavis pour n'importe quel laps de temps.
                    </li>
                      <li>Vous acceptez que Houmti ne sera pas responsable envers vous pour tout changement que nous
                      apportons à notre service.
                    </li>
                    </ol>
                  </li>
                  <li>Révisions et errata
                  <ol>
                      <li>Les éléments apparaissant sur le site Web ou les applications mobiles de Houmti peuvent inclure
                      des erreurs techniques, typographiques ou photographiques. Houmti ne garantit pas que les éléments
                      de son site Web
                      sont exacts, complets ou à jour. Houmti peut apporter des modifications aux éléments contenus sur
                      son site Web ou ses applications mobiles à tout moment et sans préavis. Cependant, Houmti ne prend
                      aucun engagement
                      de mettre à jour le matériel.

                    </li>
                    </ol>
                  </li>
                  <li>Clause de non-responsabilité

                  <ol>
                      <li>Le matériel et le contenu du site Web et des applications mobiles de Houmti sont fournis «tels
                      quels». Houmti ne donne aucune garantie, expresse ou implicite, et rejette et annule par la
                      présente toutes les autres
                      garanties, y compris, sans limitation, les garanties ou conditions implicites de qualité
                      marchande, d'adéquation à un usage particulier ou de non-violation de la propriété intellectuelle
                      ou autre violation des
                      droits.
                    </li>
                      <li>En outre, Houmti ne garantit ni ne fait aucune représentation concernant l'exactitude, les
                      résultats probables ou la fiabilité de l'utilisation des matériaux sur son site Web Internet ou
                      ses applications mobiles
                      ou autrement liés à ces matériaux ou sur tout site lié à ce site.
                    </li>
                      <li>Houmti n'est jamais, en aucun cas, responsable ou responsable des pertes ou dommages résultant
                      directement ou indirectement de votre utilisation de notre Service.</li>
                    </ol>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

export default TermsContentFr;